import React, { FC, ReactNode } from 'react'

import { ErrorBoundary } from 'components/system/ErrorBoundary'

import { BannerPlaces } from './banner.constants'
import { BannerEnabler } from './BannerEnabler'

export const GenericBanner: FC<{
  place: typeof BannerPlaces[keyof typeof BannerPlaces]
  banner: ReactNode
}> = ({ place, banner }) => {
  return (
    <BannerEnabler>
      <ErrorBoundary place={place}>{banner}</ErrorBoundary>
    </BannerEnabler>
  )
}
